import React, { useState, useEffect, useRef } from "react";
import { Award, Shield, ExternalLink } from "lucide-react";
import { getCertifications } from "../api/client";

const ICONS = { network: Shield, hardware: Award, support: Award, software: Award, cloud: Shield };

export default function Certifications() {
  const [certs, setCerts] = useState([]);
  const ref = useRef();

  useEffect(() => { getCertifications().then(setCerts).catch(console.error); }, []);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { e.target.classList.add("visible"); obs.disconnect(); } }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div style={{ padding: "120px 0", background: "var(--bg)", overflow: "hidden" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 32px" }}>

        <div ref={ref} className="reveal" style={{ marginBottom: 64, position: "relative" }}>
          <div className="ghost-number" style={{ position: "absolute", left: -20, top: -60, zIndex: 0 }}>04</div>
          <div style={{ position: "relative", zIndex: 1 }}>
            <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 12, color: "#6a6a88", letterSpacing: 3, marginBottom: 12 }}>SERTIFIKASI</div>
            <h2 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(36px, 6vw, 72px)", fontWeight: 700, color: "#f2f2ff", margin: 0, letterSpacing: "-2px", lineHeight: 1 }}>
              Kredensial &amp;<br />
              <span style={{ background: "linear-gradient(135deg,#00e5ff,#9b00ff,#ff0099,#ffb700,#00e5ff)", backgroundSize: "400% 400%", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", animation: "holo-shift 5s ease infinite" }}>Sertifikat</span>
            </h2>
          </div>
        </div>

        {/* Cards */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }} className="cert-strip">
          {certs.map((cert, i) => {
            const Icon = ICONS[cert.icon] || Award;
            return (
              <div key={cert.id}
                style={{
                  position: "relative", overflow: "hidden",
                  background: "var(--card)",
                  border: "1px solid rgba(255,255,255,0.07)",
                  borderRadius: 4, padding: "24px 20px",
                  cursor: "none",
                  animation: `fadeUp 0.6s ease ${i * 0.1}s both`,
                  transition: "transform 0.25s, border-color 0.25s, box-shadow 0.25s",
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.borderColor = `${cert.color}50`;
                  e.currentTarget.style.boxShadow = `0 20px 40px rgba(0,0,0,0.4), 0 0 0 1px ${cert.color}20`;
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.07)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                {/* Shimmer */}
                <div style={{
                  position: "absolute", inset: 0,
                  background: "linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.03) 50%, transparent 60%)",
                  backgroundSize: "400px 100%",
                  animation: "shimmer 4s linear infinite",
                  pointerEvents: "none",
                }} />

                {/* Top accent */}
                <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, transparent, ${cert.color}, transparent)` }} />

                <div style={{ width: 48, height: 48, borderRadius: 3, background: `${cert.color}15`, border: `1px solid ${cert.color}30`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
                  <Icon size={20} color={cert.color} strokeWidth={1.5} />
                </div>

                <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 14, color: "#f2f2ff", lineHeight: 1.4, marginBottom: 8 }}>{cert.name}</div>
                <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 12, color: "#6a6a88", marginBottom: 16, letterSpacing: 0.5 }}>{cert.issuer}</div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, color: cert.color, background: `${cert.color}12`, padding: "3px 10px", borderRadius: 2 }}>{cert.year}</span>
                  <ExternalLink size={13} color="rgba(255,255,255,0.15)" />
                </div>
              </div>
            );
          })}
        </div>

        {/* Coming soon strip */}
        <div style={{ marginTop: 48, padding: "20px 24px", border: "1px dashed rgba(255,255,255,0.08)", borderRadius: 4, display: "flex", alignItems: "center", gap: 16 }}>
          <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, color: "#6a6a88", letterSpacing: 1 }}>COMING SOON</div>
          <div style={{ width: 1, height: 16, background: "rgba(255,255,255,0.1)" }} />
          <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, background: "linear-gradient(135deg,#00e5ff,#9b00ff,#ff0099)", backgroundSize: "400% 400%", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", animation: "holo-shift 4s ease infinite", letterSpacing: 1 }}>
            AWS CLOUD PRACTITIONER &nbsp;&bull;&nbsp; AZURE FUNDAMENTALS
          </div>
        </div>
      </div>
    </div>
  );
}
